module.exports = __webpack_public_path__ + "static/bakeryslide-06-min-86ae6eb724a7ba3aa8a078581ec9abf8.jpg";